import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import {
  ChangesApi,
  ChangeRow,
  ListChangesOptions,
} from './ChangesApi';

export class ChangesClient implements ChangesApi {
  constructor(
    private readonly deps: { fetchApi: FetchApi; discoveryApi: DiscoveryApi },
  ) {}

  async listChanges(opts: ListChangesOptions = {}): Promise<ChangeRow[]> {
    const baseUrl = await this.deps.discoveryApi.getBaseUrl('changes');
    const url = `${baseUrl}/releases?limit=${opts.limit ?? 50}`;
    const res = await this.deps.fetchApi.fetch(url);
    if (!res.ok) throw new Error(`listChanges: ${res.statusText}`);
    const body = (await res.json()) as { items: ChangeRow[] };
    return body.items;
  }

  async getChange(releaseId: string): Promise<ChangeRow> {
    const baseUrl = await this.deps.discoveryApi.getBaseUrl('changes');
    const res = await this.deps.fetchApi.fetch(
      `${baseUrl}/releases/${encodeURIComponent(releaseId)}`,
    );
    if (!res.ok) throw new Error(`getChange: ${res.statusText}`);
    return (await res.json()) as ChangeRow;
  }
}
